import { get, post } from "../api_helper";

const GetPhysicianSchedule = async (data) => {
  const url = "get-physician-schedule";
  const response = await get(url, data);
  return response;
};

const SavePhysicianSchedule = async (data) => {
  const url = "save-physician-schedule";
  const response = await post(url, data);
  return response;
};

const BookAppointment = async (data) => {
  const url = "book-appointment";
  const response = await post(url, data);
  return response;
};

const GetBookedAppointmentsByChatId = async (chatID) => {
  const url = "get-booked-appointment-by-chat-id?chatID=" + chatID;
  const response = await get(url);
  return response;
};

const getPhysicianBookedAppointment = async () => {
  const url = "get-physician-booked-appointments";
  const response = await get(url);
  return response;
};

const getPhysicianUpcomingAppointment = async () => {
  const url = "get-physician-upcoming-appointments";
  const response = await get(url);
  return response;
};

const getPhysicianPastAppointment = async () => {
  const url = "get-physician-past-appointments";
  const response = await get(url);
  return response;
};

const getAllBookedAppointmentByPhysician = async () => {
  const url = "get-all-booked-appointments-by-physician";
  const response = await get(url);
  return response;
};

const GetUpcomingAppointmentsByUserId = async (userId) => {
  const url = "get-upcoming-appointments-by-user-id";
  const response = await get(url);
  return response;
};

const GetPastAppointmentsByUserId = async (userId) => {
  const url = "get-past-appointments-by-user-id";
  const response = await get(url);
  return response;
};

const getAllBookedAppointments = async () => {
  const url = "get-all-booked-appointments";
  const response = await get(url);
  return response;
};

const getAvailableSlots = async (date) => {
  const url = "get-available-slots?date=" + date;
  const response = await get(url);
  return response;
};

const getAppointmentDetails = async (appointmentId) => {
  const url = "get-appointment-details?appointmentId=" + appointmentId;
  const response = await get(url);
  return response;
};

export {
  GetPhysicianSchedule,
  SavePhysicianSchedule,
  BookAppointment,
  GetBookedAppointmentsByChatId,
  getPhysicianBookedAppointment,
  getPhysicianUpcomingAppointment,
  getPhysicianPastAppointment,
  GetUpcomingAppointmentsByUserId,
  GetPastAppointmentsByUserId,
  getAllBookedAppointmentByPhysician,
  getAllBookedAppointments,
  getAvailableSlots,
  getAppointmentDetails,
};
